export default __webpack_public_path__ + "static/media/2.ae989af4.svg";